import { render, staticRenderFns } from "./empOrManagerDetail.vue?vue&type=template&id=5a45b6e8&scoped=true"
import script from "./empOrManagerDetail.vue?vue&type=script&lang=js"
export * from "./empOrManagerDetail.vue?vue&type=script&lang=js"
import style0 from "./empOrManagerDetail.vue?vue&type=style&index=0&id=5a45b6e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a45b6e8",
  null
  
)

export default component.exports